import React, { useState } from 'react';
import TabelaDescontoService from '../../services/service.tabeladesconto';
import NewSearchBarControlFormik from './search-Bar.Control.Formik';

const SearchListTabelaDescontos = (props) => {
  const [descontos, setDescontos] = useState(null);
  const [pages, setPages] = useState(1);

  const columns = [
    {
      field: 'Id',
      headerName: 'Codigo',
      width: 90,
      key: true
    },
    {
      field: 'Nome',
      headerName: 'Nome',
      width: 150,
    }
  ];

  const columnsFilter = [
    {
      field: 'Id',
      headerName: 'Codigo',
      tipo: 'number'
    },
    {
      field: 'Nome',
      headerName: 'Nome',
      tipo: 'text'
    }
  ];

  const onSearchTitle = (filter) => {
    TabelaDescontoService.getAll(filter)
      .then(response => {
        setDescontos(response.data.value);
        setPages(response.data.pages);
      })
      .catch(e => {
        console.error(e);
      });
  };

  const onGetItem = (id, onLoadError) => {
    id && props.onLoad(true);
    id && TabelaDescontoService.get(id)
      .then(response => {
        if (response.response?.data.error) {
          props.onError(response.response?.data.error);
        } else {
          response.data && onItemSelected(response.data);
        }
      })
      .catch(e => {
        props.onError(e);
        onLoadError && onLoadError(e);
      })
      .finally(() => {
        props.onLoad(false);
      });
  };

  const onItemSelected = (item) => {
    props.onItemSelected(item);
  };

  return (
    <>
      <NewSearchBarControlFormik
        {...props}
        pages={pages}
        onSearchTitle={onSearchTitle}
        onGetItem={onGetItem}
        onItemSelected={onItemSelected}
        data={descontos}
        columns={columns}
        columnsFilter={columnsFilter}
        storagename={"Descontos"}
      />
    </>
  );
}

export default SearchListTabelaDescontos
